export const buildCaseFormId = (_case, pathologist) => (
  `case:${_case._id},pathologist:${pathologist._id}`
);

export const buildSpecimenFormId = (specimen, pathologist) => (
  `specimen:${specimen._id},pathologist:${pathologist._id}`
);
